export default "<gtd-shell-b2b [urlB2b]=\"urlB2b\"></gtd-shell-b2b>\n"